import { BlankSlate } from "@msuite/ui/blank-slate";
import { Panels } from "@msuite/ui/panels";
import type { PartnerPanelBaseProps } from "../types";
import { PartnerNumericAgreements } from "./partner-numeric-agreements";

export function PartnerAgreements({ orgId, partnershipId }: PartnerPanelBaseProps) {
	return (
		<Panels>
			<Panels.Panel flex={1}>
				<PartnerNumericAgreements
					orgId={orgId}
					partnershipId={partnershipId}
				/>
			</Panels.Panel>
			<Panels.Panel flex={2}>
				<BlankSlate />
			</Panels.Panel>
		</Panels>
	);
}
